import { Box, Flex } from "@chakra-ui/react";
import { Spinner } from "@chakra-ui/react";
import { ExportToPdfButton } from "../ExportToPdfButton";
import { useState } from "react";
import { Trend } from "../stats/Trend";
import { SizeStats } from "../stats/SizeStats";
import { ParityStats } from "../stats/ParityStats";
import { PrimeStats } from "../stats/PrimeStats";


export const Lotto = ({gameName, dataList, summary, loading, error, ...props}) => {
    const [activeTab, setActiveTab] = useState("trend")

    return (  
        <Box id="game" width="100%" {...props}>  

            <Flex className="export_pdf" justify="right">
                <ExportToPdfButton dataList={dataList} gameName={gameName} />
            </Flex>

            <Flex className="tabs_switch" padding="15px 0 0px" fontWeight="bold">
                <TabButton onClick={() => setActiveTab('trend')} isActive={activeTab === "trend"}>Trend</TabButton>
                <TabButton onClick={() => setActiveTab('size')} isActive={activeTab === "size"}>Size</TabButton>
                <TabButton onClick={() => setActiveTab('parity')} isActive={activeTab === "parity"}>Parity</TabButton>
                <TabButton onClick={() => setActiveTab('prime')} isActive={activeTab === "prime"}>Prime</TabButton>
            </Flex>

            <Box className="active_tab">
                {loading && <Flex justify="center" marginTop="150px"><Spinner/></Flex>}
                {error && <Box>Error occured while getting data</Box>}
                {dataList && (
                    <>                    
                    {activeTab === "trend" && <Box><Trend dataList={dataList} summary={summary} gameName={gameName}/></Box>}
                    {activeTab === "size" && <Box><SizeStats dataList={dataList} gameName={gameName}/></Box>}
                    {activeTab === "parity" && <Box><ParityStats dataList={dataList} gameName={gameName}/></Box>}
                    {activeTab === "prime" && <Box><PrimeStats dataList={dataList} gameName={gameName}/></Box>}
                    </>
                )}
            </Box>
        </Box>
    )
}



export const TabButton = ({children, isActive, ...props}) => {
    const [isHovered, setIsHovered] = useState(false)

    return (
        <Box
            padding="5px 15px"
            cursor= "pointer"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            color={isHovered ? {base:"", md:"lightgreen"} : ""}
            borderBottom = {isActive ? "3px solid green" : ""}
            borderTopRightRadius = "20px"
            {...props}
        >
            {children}
        </Box>
    )
}

